export const getRecentlySearchedCardTitle = (
  uiVariant: "hotels" | "cars" | "flights" | "packages",
  isCorporate: boolean,
  locationNameToUse?: string,
  originLocationNameToUse?: string,
  destinationLocationNameToUse?: string
) => {
  if (uiVariant === "hotels" && locationNameToUse) {
    return isCorporate
      ? `Hotels in ${locationNameToUse}`
      : `Stays in ${locationNameToUse}`;
  } else if (uiVariant === "cars" && locationNameToUse) {
    return `Rental cars in ${locationNameToUse}`;
  } else if (
    uiVariant === "flights" &&
    originLocationNameToUse &&
    destinationLocationNameToUse
  ) {
    return `${originLocationNameToUse} to ${destinationLocationNameToUse}`;
  } else if (
    uiVariant === "packages" &&
    originLocationNameToUse &&
    destinationLocationNameToUse
  ) {
    return `Package trip to ${destinationLocationNameToUse}`;
  } else {
    return undefined;
  }
};

export const getViewAllCTAText = (
  uiVariant: "hotels" | "flights" | "cars" | "packages",
  location: string
) => {
  switch (uiVariant) {
    case "hotels":
      return `View all hotels in ${location}`;
    case "flights":
      return `View flights to ${location}`;
    case "cars":
      return `View all rental cars in ${location}`;
    case "packages":
      return `View packages to ${location}`;
    default:
      return undefined;
  }
};
